import Select from '@blocks/Select'
import React from 'react'

export default function SectionInput({ id, idx, name, sections }: JuryInputProps) {
    const sectionOption = name ? { value: id.toString(), label: name} : undefined
    return <Select id={`section-${id}`} value={sectionOption} name="sections[]" label={`Section #${idx + 1}`} options={sections} required />
}

type SectionWithId = Partial<Interfaces.Section> & Pick<Interfaces.Section, "id">

interface JuryInputProps extends SectionWithId {
    idx: number,
    sections?: Interfaces.Options
}